import classNames from 'classnames';
import styles from './FJResourcePanel.module.less';
import FJVirtualizedMixView from '../FJVirtualizedMixView/FJVirtualizedMixView';
import FJImage from '../FJImage/FJImage';
import FJButton, { FJButtonType } from '../FJButton/FJButton';
import { useMemo, useCallback } from 'react';
import FJLocalStore from '../../../store/FJLocalStore';
import FJLoading from '../FJLoading/FJLoading.jsx';
import FJOppsIcon from '../../../assets/svg/oops.svg?react';
import FJConfig from '../../../config/FJConfig.js';
import FJAppConstant from '../../../constants/FJAppConstant.js';
import FJHeaderConfig from '../../../config/FJHeaderConfig.js';

const FJResourcePanel = props => {
    const {
        list,
        sizeList,
        renderItem,

        rowSpace = 8,
        verticalSpace = 8,
        row = 2,
        viewWidth = 166,

        className,
        scrollerClassName,

        isShowLoading = false,
        isShowError = false,
        isShowEmpty = false,

        historyType,
        onClickRetry,
    } = props;

    const isVideo = historyType === FJAppConstant.TEXT_TO_VIDEO || historyType === FJAppConstant.IMAGE_TO_VIDEO;
    const currentLanguage = FJLocalStore.currentTag();

    const _renderEmpty = useMemo(() => {
        if (!historyType) {
            return <div className={styles.empty}>{<div className={styles.empty_text}>No data</div>}</div>;
        }

        let imgSrc = '';
        let desc = '';
        let btnText = '';
        let jumpUrl = '';

        switch (historyType) {
            case FJAppConstant.TEXT_TO_IMAGE:
                imgSrc = FJConfig.usePhotoTextToImageHistoryNullPng + '?v=' + FJConfig.version;
                desc = FJLocalStore._('no-AI-images-yet-generate-AI-images-from-text-right-now');
                btnText = 'start-now';
                jumpUrl = FJHeaderConfig.aiMenuList.find(item => item.title === 'ai-text-to-image').href;
                break;
            case FJAppConstant.IMAGE_TO_IMAGE:
                imgSrc = FJConfig.usePhotoImageToImageHistoryNullPng + '?v=' + FJConfig.version;
                desc = FJLocalStore._('no-AI-images-yet-generate-AI-images-from-photos-right-now');
                jumpUrl = FJHeaderConfig.aiMenuList.find(item => item.title === 'ai-image-to-image').href;
                btnText = 'start-now';
                break;
            case FJAppConstant.TEXT_TO_VIDEO:
                imgSrc = FJConfig.usePhotoTextToVideoHistoryNullPng + '?v=' + FJConfig.version;
                desc = FJLocalStore._('no-ai-videos-yet');
                btnText = 'start-now';
                jumpUrl =
                    FJHeaderConfig.aiMenuList.find(item => item.title === 'ai-video-generator').href + '?tab_type=tv';
                break;
            case FJAppConstant.IMAGE_TO_VIDEO:
                imgSrc = FJConfig.usePhotoImageToVideoHistoryNullPng + '?v=' + FJConfig.version;
                desc = FJLocalStore._('no-ai-videos-yet');
                btnText = 'start-now';
                jumpUrl =
                    FJHeaderConfig.aiMenuList.find(item => item.title === 'ai-video-generator').href + '?tab_type=iv';
                break;
        }

        return (
            <div className={styles.text_to_image_history_empty}>
                <FJImage isShowLoading={true} imgSrc={imgSrc} boxClassName={styles.text_to_image_history_empty_img} />
                <div className={styles.text_to_image_history_empty_text}>{desc}</div>
                <FJButton
                    className={styles.text_to_image_history_empty_btn}
                    type={FJButtonType.GRADIENT}
                    text={btnText}
                    onClick={() => {
                        window.open(jumpUrl, '_blank');
                    }}
                />
            </div>
        );
    }, [historyType, currentLanguage]);

    const _renderError = useCallback(() => {
        return (
            <div className={styles.status_box}>
                <FJOppsIcon />
                <div className={styles.status_text}>
                    {isVideo
                        ? FJLocalStore._('failed-to-load-video-please-try-again')
                        : FJLocalStore._('failed-to-load-image-please-try-again')}
                </div>
                <FJButton text='retry' onClick={onClickRetry} className={styles.retry_btn} />
            </div>
        );
    }, [isVideo]);

    const _renderLoading = useCallback(() => {
        return (
            <div className={styles.status_box}>
                <FJLoading strokeColor='#a8acbc' />
            </div>
        );
    }, []);

    return (
        <div className={classNames(styles.resource_panel, className)}>
            <FJVirtualizedMixView
                className={classNames(styles.virtualized_mix_view, scrollerClassName)}
                list={list}
                renderItem={renderItem}
                childrenSizeList={sizeList}
                viewWidth={viewWidth}
                row={row}
                rowSpace={rowSpace}
                verticalSpace={verticalSpace}
            />
            {isShowLoading && _renderLoading()}
            {isShowError && _renderError()}
            {isShowEmpty && _renderEmpty}
        </div>
    );
};

export default FJResourcePanel;
